import React from 'react';
import SectionContainer from '../../../common/SectionContainer';
import { formatCurrency } from '../../../common/formatUtils';
import { r20 as r20Fn } from '../formulas';

const Cell = ({ code, value }) => (
  <div className="f22-rtre-cell">
    {code && <span className="f22-rtre-code">{code}</span>}
    <span>{value !== undefined && value !== 0 ? formatCurrency(value) : ''}</span>
  </div>
);

const R20Section = ({ data }) => {
  const rem = r20Fn.remanente(data);
  const remSig = r20Fn.remanenteSiguiente(data);

  const rows = [
    {
      label: 'Remanente ejercicio anterior (saldo positivo)',
      codes: { RAI: '1451', REX_INR: '1454', STUT: '1382' },
      values: rem,
    },
    {
      label: 'Reversos y/o disminuciones (propios)',
      codes: { RAI: '1459' },
      values: { RAI: r20Fn.reverso(data).RAI },
    },
    {
      label: 'Aumentos del ejercicio (propios)',
      codes: { RAI: '1463' },
      values: { RAI: r20Fn.aumentoRAI(data).RAI },
    },
    {
      label: 'Otros aumentos del ejercicio',
      codes: { REX_INR: '1470', STUT: '1387' },
      values: { REX_INR: r20Fn.aumentoINR(data).REX_INR },
    },
    {
      label: 'Retiros imputados a RTRE',
      codes: { RAI: '1475' },
      values: { RAI: r20Fn.retiros(data) },
    },
    {
      label: 'Remanente ejercicio siguiente',
      codes: { RAI: '1484', REX_INR: '1487', STUT: '1391' },
      values: remSig,
      isTotal: true,
    },
  ];

  return (
    <SectionContainer title="Recuadro N° 20" subtitle="Registro Tributario de Rentas Empresariales y Movimiento STUT">
      <div className="f22-rtre-table-wrapper">
        <div className="f22-rtre-table">
          <div className="f22-rtre-header">
            <div className="f22-rtre-cell f22-rtre-header-cell" style={{ flex: 3 }}>Detalle</div>
            <div className="f22-rtre-cell f22-rtre-header-cell">RAI</div>
            <div className="f22-rtre-cell f22-rtre-header-cell">INR</div>
            <div className="f22-rtre-cell f22-rtre-header-cell">STUT</div>
          </div>
          {rows.map((row, i) => (
            <div key={i} className={`f22-rtre-row ${row.isTotal ? 'f22-rtre-total' : ''}`}>
              <div className="f22-rtre-cell" style={{ flex: 3, textAlign: 'left', fontFamily: 'inherit' }}>
                {row.label}
              </div>
              <Cell code={row.codes?.RAI} value={row.values.RAI} />
              <Cell code={row.codes?.REX_INR} value={row.values.REX_INR} />
              <Cell code={row.codes?.STUT} value={row.values.STUT} />
            </div>
          ))}
        </div>
      </div>
    </SectionContainer>
  );
};

export default R20Section;
